HHS.analytics = {};

// ----- Init analytics

HHS.analytics.init = function analytics_init(){

	log("Initializing analytics...");

	// Spin up Google Analytics

	(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
		(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
		m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
	})(window,document,'script','//www.google-analytics.com/analytics.js','ga');

	ga('create', ('UA-21730745-1'), 'auto');
	ga('send', 'pageview');

};

// ----- Send event

HHS.analytics.trackEvent = function trackEvent(category, action, label, value) {

	var hit = {
		'hitType': 'event', // Required
		'eventCategory': category, // Required
		'eventAction': action, // Required
		'eventLabel': label,
		'eventValue': (value || 1)
	};

	log("Sending tracked event.", hit);
	ga('send', hit);


};